import { PageLayoutDefaultMenuNavigationLinkItem } from "@sis/react-library";
import { RouteObject } from "react-router-dom";
import ScheduleIcon from '@mui/icons-material/Schedule';
import { SchedulePage } from "./schedulePage/SchedulePage";
import { ScheduleMainPage } from "./scheduleMainPage/ScheduleMainPage";
import { ScheduleWinPage } from "./scheduleWinPage/ScheduleWinPage";
import { ScheduleDerivsPage } from "./scheduleDerivsPage/ScheduleDerivsPage";

const url = "schedule";

// use in same file
// eslint-disable-next-line
export const scheduleRoutes = {
    root: `/${url}`,

    main: `main`,
    win: 'win/',
    derivs: 'derivs/',

    match: ":eventId",
}

// use in same file
// eslint-disable-next-line
export const scheduleRoutesCombined = {
    main: `${scheduleRoutes.root}/${scheduleRoutes.main}`,
    win_eventMatch: `${scheduleRoutes.root}/${scheduleRoutes.win}${scheduleRoutes.match}`,
    derivs_eventMatch: `${scheduleRoutes.root}/${scheduleRoutes.derivs}${scheduleRoutes.match}`
}

export const ScheduleNavigation = (): RouteObject[] => {
    return [
        {
            path: scheduleRoutes.root,
            element: <SchedulePage />,
            children: [
                {
                    path: scheduleRoutes.main,
                    element: <ScheduleMainPage />
                },
                {
                    path: `${scheduleRoutes.win}${scheduleRoutes.match}`,
                    element: <ScheduleWinPage />
                },
                {
                    path: `${scheduleRoutes.derivs}${scheduleRoutes.match}`,
                    element: <ScheduleDerivsPage />
                }
            ]
        }
    ]
}

export const ScheduleMenuItems = (): PageLayoutDefaultMenuNavigationLinkItem[] =>
    [{ icon: <ScheduleIcon />, text: 'Schedule', navigateTo: scheduleRoutes.root }]